/* global angular */
import moment from 'moment';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function CABeginServiceTrialDialogController(
  $rootScope,
  $q,

  alerts,
  ssDialogService,
  orgDataService,
  loaderService
) {
  const vm = this;

  const bankAdminAlertsCopy = copy.admin.customerAdministration.alerts;

  vm.trialEndDate = moment().add(30, 'days');
  vm.minTrialEndDate = moment().add(1, 'days');

  vm.handleServiceTrialEndDateBlur = _handleServiceTrialEndDateBlur;
  vm.handleCreateTrialClick = _handleCreateTrialClick;
  vm.handleCloseDialogClick = _handleCloseDialogClick;

  // Date Picker
  function _handleServiceTrialEndDateBlur($event) {
    vm.trialEndDate = moment(angular.element($event.target).val());
  }

  function _handleCreateTrialClick() {
    if (_validateTrialEndDate()) {
      const customerService = {
        agreementType: 3,
        customerId: vm.customerId,
        serviceId: vm.serviceId,
        isActive: true,
        endDate: moment(vm.trialEndDate).format('MM/DD/YYYY'),
      };
      vm.createTrialButtonIsDisabled = true;
      loaderService.showViewLoader = true;
      orgDataService.saveCustomerService(customerService)
        .then(() => {
          alerts.success(bankAdminAlertsCopy.createServiceTrialSuccessful.text);
          ssDialogService.hide(ssDialogService.dialogs.admin.beginServiceTrialDialog);
          $rootScope.$broadcast('refreshCustomer', { customerId: vm.customerId });
        })
        .finally(() => {
          vm.createTrialButtonIsDisabled = false;
          loaderService.showViewLoader = false;
        });
    }
  }

  function _validateTrialEndDate() {
    let isValid = false;
    if (vm.trialEndDate) {
      if (moment(vm.trialEndDate).isBefore(moment())) {
        alerts.error(bankAdminAlertsCopy.serviceTrialEndDateExpired.text);
      } else {
        isValid = true;
      }
    } else {
      alerts.error(bankAdminAlertsCopy.serviceTrialEndDateFormatInvalid.text);
    }
    return isValid;
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.admin.beginServiceTrialDialog);
  }
}

CABeginServiceTrialDialogController.$inject = [
  '$rootScope',
  '$q',

  'alerts',
  'ssDialogService',
  'orgDataService',
  'loaderService'
];
